@if (prodOrderTransit$ | async) {
  <div class="layout-col full">
    <elder-pane>
      <elder-pane-content>
        <div class="flex layout-col gap-md">
          <div class="flex-60 layout-col">
            <elder-pane-subtitle>{{
              'transit.orders.involvedWorkOrders' | translate
            }}</elder-pane-subtitle>
            <elder-table class="flex" dense matSort [data]="assignmentsCtx">
              <!-- id Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef style="width: 10%">
                  {{ 'context.id' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  <div class="layout-col place-center-start">
                    <span>{{ transitAssignment.workOrderId }}</span>
                  </div>
                </td>
              </ng-container>
              <!-- productionDate Column -->
              <ng-container matColumnDef="productionDate">
                <th mat-header-cell *matHeaderCellDef style="width: 10%">
                  {{ 'transit.orders.productionDate' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  <div class="layout-col place-center-start">
                    <span>{{ getScheduleInterval(transitAssignment) | isoInterval }}</span>
                  </div>
                </td>
              </ng-container>
              <!-- description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>{{ 'context.description' | translate }}</th>
                <td mat-cell *matCellDef="let transitAssignment">
                  <div class="layout-col place-center-start">
                    <span>{{ getDescription(transitAssignment) }}</span>
                    <span class="text-body-small">{{
                      getProjectDescription(transitAssignment)
                    }}</span>
                  </div>
                </td>
              </ng-container>
              <!-- facility Column -->
              <ng-container matColumnDef="facility" style="width: 5%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'facilities.productionFacility' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  {{ getManufacturingFacility(transitAssignment) }}
                </td>
              </ng-container>
              <!-- weight Column -->
              <ng-container matColumnDef="weight" style="width: 5%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'context.weight' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  {{ getTotalWeight(transitAssignment) | elderQuantity }}
                </td>
              </ng-container>
              <!-- delivery Column -->
              <ng-container matColumnDef="delivery" style="width: 20%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'deliveries.delivery' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment; let i = index">
                  <mat-form-field elderDense class="full py-sm" subscriptSizing="dynamic">
                    <elder-select
                      appDeliverySelect
                      [allowNull]="true"
                      [filters]="deliveriesCtx.filter.filters | async"
                      valueAsId
                      [(value)]="transitAssignment.deliveryId"
                      (entityUpdated)="onDeliveryAssigned(transitAssignment)"
                    ></elder-select>
                  </mat-form-field>
                </td>
              </ng-container>
              <!-- transportDate Column -->
              <ng-container matColumnDef="transportDate">
                <th mat-header-cell *matHeaderCellDef style="width: 15%">
                  {{ 'transit.orders.transportDate' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  <div class="layout-col place-center-start">
                    <span>{{ getDeliveryPickupTimeFrame(transitAssignment) | isoInterval }}</span>
                  </div>
                </td>
              </ng-container>
              <!-- dispatch state Column -->
              <ng-container matColumnDef="deliveryStatus" style="width: 5%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'deliveries.deliveryOrderSchedulingState' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  <app-state-icon
                    [state]="getSchedulingState(transitAssignment)"
                    [mapStateToIcon]="mapScheduleStateToIcon"
                  ></app-state-icon>
                </td>
              </ng-container>
              <!-- transport state Column -->
              <ng-container matColumnDef="transportStatus" style="width: 5%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'deliveries.deliveryOrderTransportState' | translate }}
                </th>
                <td mat-cell *matCellDef="let transitAssignment">
                  <app-state-icon
                    [state]="getTransportState(transitAssignment)"
                    [mapStateToIcon]="mapTransportStateToIcon"
                  ></app-state-icon>
                </td>
              </ng-container>
            </elder-table>
          </div>

          <div class="flex layout-col">
            <elder-pane-subtitle>{{
              'deliveries.plannedDeliveries' | translate
            }}</elder-pane-subtitle>
            <elder-table class="flex" dense matSort [data]="deliveriesCtx">
              <ng-container matColumnDef="delivery">
                <th mat-header-cell *matHeaderCellDef>{{ 'deliveries.delivery' | translate }}</th>
                <td mat-cell *matCellDef="let delivery">
                  <div class="layout-col">
                    <span>{{ delivery.id }}</span>
                    <span class="text-body-small">Ref: {{ delivery?.orderReferenceNumber }}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="facility" style="width: 10%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'context.placeOfDeparture' | translate }}
                </th>
                <td mat-cell *matCellDef="let delivery">{{ delivery?.facilityId }}</td>
              </ng-container>
              <ng-container matColumnDef="targetWeight" style="width: 10%">
                <th mat-header-cell *matHeaderCellDef elderNumberCell>
                  {{ 'context.targetWeight' | translate }}
                </th>
                <td mat-cell *matCellDef="let delivery" elderNumberCell>
                  {{ delivery?.targetWeight | elderQuantity }}
                </td>
              </ng-container>
              <ng-container matColumnDef="pickUpDate">
                <th mat-header-cell *matHeaderCellDef style="width: 15%">
                  {{ 'deliveries.pickUpDate' | translate }}
                </th>
                <td mat-cell *matCellDef="let delivery">
                  <div class="layout-col place-center-start">
                    <span>{{ delivery?.pickUpTimeFrame | isoInterval }}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="dropOffDate">
                <th mat-header-cell *matHeaderCellDef style="width: 15%">
                  {{ 'deliveries.dropOffDate' | translate }}
                </th>
                <td mat-cell *matCellDef="let delivery">
                  <div class="layout-col place-center-start">
                    <span>{{ delivery?.dropOffTimeFrame | isoInterval }}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="deliveryStatus" style="width: 5%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'deliveries.deliveryOrderSchedulingState' | translate }}
                </th>
                <td mat-cell *matCellDef="let delivery">
                  <app-state-icon
                    [state]="delivery?.schedulingState"
                    [mapStateToIcon]="mapScheduleStateToIcon"
                  ></app-state-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="transportStatus" style="width: 5%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'deliveries.deliveryOrderTransportState' | translate }}
                </th>
                <td mat-cell *matCellDef="let delivery">
                  <app-state-icon
                    [state]="delivery?.transportState"
                    [mapStateToIcon]="mapTransportStateToIcon"
                  ></app-state-icon>
                </td>
              </ng-container>
            </elder-table>
          </div>
        </div>
      </elder-pane-content>
    </elder-pane>
  </div>
}
